import { useEffect, useState } from 'react';
import Sheet from '../components/Sheet';
import { PRIMARY } from '../components/CaptureSheets';
import { Group, NumberField, Row } from '../components/SettingsRows';
import { useApp } from '../lib/AppContext';
import { today } from '../lib/dates';

// The toast after saving: targets start tomorrow when the student already logged a meal today.
export const savedText = (saved) => `Đã đặt mục tiêu cho ${saved.name}${saved.effective_from > today() ? ', áp dụng từ ngày mai' : ''}`;

const toForm = (t) => ({
  calorie_goal: t?.calorie_goal ?? '', protein_goal: t?.protein_goal ?? '', workout_protein_goal: t?.workout_protein_goal ?? '',
});

// "Đặt mục tiêu": the coach sets a student's calories and protein. Prefilled with the student's current
// targets; the student is told, makes their own menu from them and can still change them.
export default function TargetsSheet({ student, onClose, onSaved }) {
  const { api } = useApp();
  const [form, setForm] = useState(toForm(student));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // Opened from the Học viên list the row has no targets yet: read them.
  useEffect(() => {
    setError(null);
    if (!student) return;
    if (student.calorie_goal !== undefined) { setForm(toForm(student)); return; }
    setForm(toForm(null));
    api.get('/coach/targets').then((data) => setForm(toForm(data.students.find((s) => s.client_id === student.client_id)))).catch(() => {});
  }, [api, student]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const saved = await api.put(`/coach/students/${student.client_id}/targets`, form);
      onSaved?.(saved);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const set = (key) => (value) => setForm((f) => ({ ...f, [key]: value }));
  return (
    <Sheet open={!!student} onClose={onClose} title={`Mục tiêu cho ${student?.name || 'học viên'}`}>
      <form className="flex flex-col gap-4" onSubmit={save}>
        <Group>
          <Row label="Calo mỗi ngày" htmlFor="coach-kcal"><NumberField id="coach-kcal" unit="kcal" value={form.calorie_goal} onChange={set('calorie_goal')} /></Row>
          <Row label="Đạm ngày nghỉ" htmlFor="coach-protein"><NumberField id="coach-protein" unit="g" value={form.protein_goal} onChange={set('protein_goal')} /></Row>
          <Row label="Đạm ngày tập" hint="Để trống nếu như ngày nghỉ" htmlFor="coach-wprotein">
            <NumberField id="coach-wprotein" unit="g" value={form.workout_protein_goal} onChange={set('workout_protein_goal')} />
          </Row>
        </Group>
        <p className="text-xs text-muted">Học viên được báo và tự lên thực đơn theo mục tiêu này. Nếu hôm nay họ đã ghi bữa, mục tiêu mới áp dụng từ ngày mai. Họ vẫn đổi được; bạn sẽ được báo khi họ đổi.</p>
        {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}
        <button type="submit" className={PRIMARY} disabled={busy || !form.calorie_goal}>
          {busy && <span className="loading loading-spinner loading-sm" />} Lưu và báo cho {student?.name || 'học viên'}
        </button>
      </form>
    </Sheet>
  );
}
